<template>
  <input
    class="AcceptInput"
    ref="txtAcceptInput"
    :type="type"
    v-model="inputValue"
    :placeholder="placeholder"
    :class="{invalidInput:!isValid}"
    :maxlength="maxlength"
    :disabled="disabled"
    @keydown="onKeyDown"
    @keyup="onKeyUp"
    @blur="onBlur"
    @input="onInput"
  />
</template>
<script>
export default {
  name: "AcceptInput",
  props: {
    placeholder: { type: String, default: "" },
    regExp: { type: String, default: "" },
    type: { type: String, default: "text" },
    validate: { type: String, default: "" },
    value: { default: "" },
    maxlength: { type: String },
    disabled: { type: Boolean, default: false },
    isRequired: { type: Boolean, default: false }
  },
  data() {
    return {
      inputValue: "",
      checkExpression: null,
      validator: null,
      isValid: true
    };
  },
  methods: {
    focus() {
      this.$refs.txtAcceptInput.focus();
    },
    onKeyDown(e) {
      if (e.key.length > 1) {
        return;
      }
      let str = e.target.value + e.key;
      if (this.checkExpression) {
        let r = this.checkExpression.exec(str);
        if (r && r.length > 0) {
          str = r[0];
        } else {
          str = "";
        }
      }

      if (!(str && e.target.value != str)) {
        e.stopPropagation();
        e.preventDefault();
        e.target.value = str;
      }

      this.$emit("keydown", e);
    },
    onKeyUp(e) {
      switch (this.type.toLowerCase()) {
        case "aadhaar":
          if (e.key.length == 1) {
            if (e.target.value.length == 4 || e.target.value.length == 9) {
              e.target.value += "-";
            }
          }
          break;
        case "pan":
        case "gstin":
          e.target.value = e.target.value.toUpperCase();
          break;
      }

      this.$emit("keyup", e);
    },
    onBlur(e) {
      let val = e.target.value;
      let str = this.checkInputValidation(val);
      this.checkValidation();
      this.$emit("input", str);
      this.$emit("blur", e);
      if (str != val) {
        let vu = this;
        window.setTimeout(function() {
          vu.inputValue = val;
          vu.isValid = false;
        });
      }
    },
    onInput(e) {
      if (!this.validator) {
        this.$emit("input", e.target.value);
      }
    },
    checkInputValidation(str) {
      if (this.validator) {
        let r = this.validator.exec(str);
        if (r && r.length > 0) {
          str = r[0];
        } else {
          str = "";
        }
        return str;
      } else {
        return str;
      }
    },
    checkValidation() {
      let val = this.$refs.txtAcceptInput.value;
      let str = this.checkInputValidation(val);
      if (str && str === val) {
        this.isValid = true;
      } else if (str && str !== val) {
        this.isValid = false;
      } else if (val) {
        this.isValid = false;
      } else if (!str && this.isRequired) {
        this.isValid = false;
      } else {
        this.isValid = true;
      }
      return this.isValid;
    }
  },
  computed: {
    classList() {
      return this.$refs.txtAcceptInput.classList;
    }
  },
  watch: {
    value(newvalue, oldvalue) {
      this.inputValue = newvalue.toString();
      if (newvalue == "") {
        this.isValid = true;
      }
    }
  },
  mounted() {
    if (this.regExp) {
      this.checkExpression = new RegExp(this.regExp);
    }
    this.inputValue = this.value.toString().trim();
    switch (this.type.toLowerCase()) {
      case "mobile":
        this.checkExpression = new RegExp("(\\d){0,10}");
        break;
      case "phone":
        this.checkExpression = new RegExp("([+0-9\\s\\-])*");
        break;
      case "aadhaar":
        this.checkExpression = new RegExp("([\\d-]){0,14}");
        break;
      case "pan":
        this.checkExpression = new RegExp("[a-zA-Z0-9]{0,10}");
        break;
      case "gstin":
        this.checkExpression = new RegExp("[a-zA-Z0-9]{0,15}");
        break;
    }
    if (this.validate.trim()) {
      this.validator = new RegExp(this.validate.trim());
    }
    switch (this.type.toLowerCase()) {
      case "mobile":
        this.validator = new RegExp("^(\\d){10}$");
        break;
      case "phone":
        this.validator = new RegExp(
          "^([+]?\\d{1,2}[\\-\\s]?)?(\\d{3}[-]?){2}\\d{4}$"
        );
        break;
      case "email":
        this.validator = new RegExp(
          "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+).([a-zA-Z]{2,5})$"
        );

        break;
      case "url":
        this.validator = new RegExp(
          "(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-\\/]))?"
        );
        break;
      case "aadhaar":
        this.validator = new RegExp(
          "^(\\d){4}([- ]){0,1}(\\d){4}([- ]){0,1}(\\d){4}$"
        );

        break;
      case "pan":
        this.validator = new RegExp("^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$");
        break;
      case "gstin":
        this.validator = new RegExp(
          "^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[A-Za-z]{1}[Z]{1}[a-zA-Z0-9]{1}$"
        );
        break;
    }
  }
};
</script>
<style>
input.invalidInput,
label.invalidInput,
select.invalidInput,
textarea.invalidInput {
  border: solid 1px red;
  background-image: linear-gradient(rgba(255, 0, 0, 0.1));
  background-color: white;
}
label.invalidInput {
  padding: 3px;
  display: block;
}
input[type="pan"],
input[type="gstin"] {
  text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// src/components/ekkControls/AcceptInput.vue